import { render, staticRenderFns } from "./StatisticsPanel.vue?vue&type=template&id=72d13d10&scoped=true"
import script from "./StatisticsPanel.vue?vue&type=script&lang=js"
export * from "./StatisticsPanel.vue?vue&type=script&lang=js"
import style0 from "./StatisticsPanel.vue?vue&type=style&index=0&id=72d13d10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d13d10",
  null
  
)

export default component.exports